import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
//import "tom-select/dist/css/tom-select.css";

export default class extends Controller {
  static values = {
    url: String,
  };

  connect() {
    console.log("set_select controller.connect")
    fetch(this.urlValue)
      .then((res) => res.json())
      .then((options) => {
        new TomSelect(this.element, {
          options: options,
          valueField: "code",
          labelField: "label",
          searchField: ["label", "code", "name"],
          maxOptions: 1001,
          placeholder: "Select a set...",
        });
      });
  }
}
